import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import {
  ActivatedRoute,
  ActivatedRouteSnapshot,
  Router,
} from '@angular/router';
import { AppConfig } from 'src/app/configs/app.config';

@Injectable({
  providedIn: 'root',
})
export class UrlUtilService {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _location: Location
  ) {}

  private readonly globalParamType: string = AppConfig.URL_PARAM_TYPE;

  encryptUrl(url: string, paramType: string) {
    let newUrl = url;
    let indexParamType = url.indexOf(paramType);
    if (indexParamType > 0) {
      let state = url.substring(0, indexParamType + 1);
      let urlParam = url.substring(indexParamType + 1);
      let paramsEnc = encodeURIComponent('{{' + window.btoa(urlParam) + '}}');
      newUrl = state + paramsEnc;
    }
    return newUrl;
  }

  decryptUrl(url: string, paramType: string) {
    let newUrl = url;
    let indexParamType = url.indexOf(paramType);
    if (indexParamType > 0) {
      let state = url.substring(0, indexParamType + 1);
      let urlParam = url.substring(indexParamType + 1);
      let urlParamDecode = decodeURIComponent(urlParam);
      if (urlParamDecode.startsWith('{{')) {
        //if encrypted ,then decrypt
        let param = urlParamDecode.substring(
          urlParamDecode.lastIndexOf('{{') + 2
        );
        if (urlParamDecode.lastIndexOf('}}') > 0) {
          param = param.substring(0, urlParamDecode.lastIndexOf('}}'));
        }
        newUrl = state + window.atob(param.replace('{{', '').replace('}}', ''));
      }
    }
    return newUrl;
  }

  refreshPage(url: string) {
    // this.router.navigateByUrl(url);
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigateByUrl(url);
    });
  }

  redirectPage(url: string, params: any = null) {
    let routeUrl = !!params
      ? this.router.serializeUrl(this.router.createUrlTree([url, params]))
      : this.router.serializeUrl(this.router.createUrlTree([url]));
    let encryptUrl = this.encryptUrl(routeUrl, this.globalParamType);
    this.router.navigateByUrl(encryptUrl);
  }

  redirectPageSkipLocationChange(url: string, params: any = null) {
    let routeUrl = !!params
      ? this.router.serializeUrl(this.router.createUrlTree([url, params]))
      : this.router.serializeUrl(this.router.createUrlTree([url]));
    let encryptUrl = this.encryptUrl(routeUrl, this.globalParamType);
    this._location.replaceState(encryptUrl);
  }

  openNewTab(url: string, params: any = null) {
    let routeUrl = !!params
      ? this.router.serializeUrl(this.router.createUrlTree([url, params]))
      : this.router.serializeUrl(this.router.createUrlTree([url]));
    let encryptUrl = this.encryptUrl(routeUrl, this.globalParamType);
    window.open(encryptUrl);
  }

  openLinkNewTab(url: string) {
    if (url.startsWith('https://')) {
      url = url.replace('https://','')
    } else if (url.startsWith('http://')) {
      url = url.replace('http://','')
    }
    window.open('//' + url, '_blank');
  }

  encryptUrlHref(url: string, params: any = null) {
    let routeUrl = !!params
      ? this.router.serializeUrl(this.router.createUrlTree([url, params]))
      : this.router.serializeUrl(this.router.createUrlTree([url]));
    let encryptUrl = this.encryptUrl(routeUrl, this.globalParamType);
    return encryptUrl;
  }

  getUrlParam(route: ActivatedRoute, paramName: string) {
    return route.snapshot.data[paramName]
      ? route.snapshot.data[paramName]
      : route.snapshot.paramMap.get(paramName)
      ? route.snapshot.paramMap.get(paramName)
      : route.snapshot.queryParams[paramName];
  }

  getUrlParam2(route: ActivatedRoute, url: string, paramName: string) {
    // console.log(this.decryptUrl(url, this.globalParamType));

    let urlDecode = this.decryptUrl(url, this.globalParamType);
    // console.log(route, url, this.router.parseUrl(urlDecode));
    const segments =
      this.router.parseUrl(urlDecode).root.children['primary']?.segments;
    const curSegment = segments?.find(
      (x) => x.path === route.snapshot.routeConfig?.path
    );
    let result;
    // console.log(curSegment);
    if (!!curSegment) {
      result =
        curSegment.parameterMap.get(paramName) ??
        curSegment.parameters[paramName];
    }
    return result;
  }

  getUrlParamAuthGuard(
    route: ActivatedRouteSnapshot,
    url: string,
    paramName: string
  ) {
    // console.log(this.decryptUrl(url, this.globalParamType));
    let urlDecode = this.decryptUrl(url, this.globalParamType);
    // console.log(route, url, this.router.parseUrl(urlDecode));
    const segments =
      this.router.parseUrl(urlDecode).root.children['primary']?.segments;
    const curSegment = segments?.find(
      (x) => x.path === route.routeConfig?.path
    );
    let result;
    // console.log(curSegment);
    if (!!curSegment) {
      result =
        curSegment.parameterMap.get(paramName) ??
        curSegment.parameters[paramName];
    }
    return result;
  }
}
